import React, {Component} from 'react';
import Navbar from "../components/base/Navbar";
import Footer from "../components/base/Footer";
import Promotion from "../components/Promotion";
import Contact from "../components/Contact";
import NewsletterYears from "../components/NewsletterYears";
import NewsletterAbo from "../components/NewsletterAbo";

function Main() {

    const ref = React.useRef(null);

    return (
        <div>
            <div className="bg-gray-200 pt-24 bg-center">
                <Navbar/>

                <div className="relative isolate px-6 lg:px-8">
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%-11rem)] aspect-1155/678 w-144.5 -translate-x-1/2 rotate-30 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75"
                        />
                    </div>
                    <div className="mx-auto max-w-2xl py-8 sm:py-24 lg:py-32">
                        <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                            <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-700 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                                Erhalte immer der neusten News!{' '}
                                <a href="/newsletter" className="font-semibold text-blue-600">
                                    <span aria-hidden="true" className="absolute inset-0" />
                                    Read more <span aria-hidden="true">&rarr;</span>
                                </a>
                            </div>
                        </div>
                        <div className="text-center">
                            <h1 className="text-5xl font-semibold tracking-tight text-balance text-gray-700 sm:text-7xl">
                                Rechtsanwalt
                            </h1>
                            <p className="mt-8 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
                                Rechtsanwalt für Sie! Wir helfen Ihnen bei allen Fragen rund um das Arbeitsrecht.
                            </p>
                            <div className="mt-10 flex items-center justify-center gap-x-6">
                                <a
                                    href="mailto:info@us-arbeitsrecht.de"
                                    className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    Jetzt anfragen
                                </a>
                                <a href="#" className="text-sm/6 font-semibold text-gray-900" onClick={() => ref.current?.scrollIntoView({ behavior: "smooth", block: "start" })}>
                                    Learn more <span aria-hidden="true">→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%+3rem)] aspect-1155/678 w-144.5 -translate-x-1/2 bg-linear-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-288.75"
                        />
                    </div>
                </div>




                <div className="w-full m-12"></div>

                <div className="bg-gray-100/50 bg-border h-[5px]"></div>

                <div className="w-full m-12"></div>

                <section  ref={ref} className="scroll-mt-24">
                    <Promotion/>
                </section>

                <div className="w-full m-12"></div>

                <div className="bg-gray-100/50 bg-border h-[5px]"></div>

                <NewsletterYears/>

                {/*<div className="bg-gray-100/50 bg-border h-[5px]"></div>

                <div className="w-full m-12"></div>

                <NewsletterAbo/>*/}

                <div className="w-full m-12"></div>

                <div className="bg-gray-100/50 bg-border h-[5px]"></div>

                <Contact/>

                <div className="w-full m-12"></div>

                <Footer/>
            </div>

        </div>
    );
}

export default Main;